import { Component, input } from '@angular/core';
import { Nillable } from '@web/utils';

@Component({
  selector: 'app-number',
  imports: [],
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss'],
})
export class NumberComponent {
  public readonly value = input.required<number>();
  public readonly unit = input<Nillable<string>>(null);
}
